import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AlertModule } from "@storeblocks/alert-ng";
import { FmsService } from "src/app/services/fms.service";

type AlertVariant = "error" | "warning" | "success" | "info" | "info-subtle";

const VALID_TYPES: readonly AlertVariant[] = ["error", "warning", "success", "info", "info-subtle"];

const ALERT_BACKGROUNDS: Record<AlertVariant, string> = {
  error: "var(--p-color-surface-error)",
  warning: "var(--p-color-surface-warning)",
  success: "var(--p-color-surface-success)",
  info: "var(--p-color-surface-info)",
  "info-subtle": "var(--p-color-surface-1)",
};

function resolveAlertType(raw: string): AlertVariant {
  if (raw === "subtle") {
    return "info-subtle";
  }
  return VALID_TYPES.includes(raw as AlertVariant) ? (raw as AlertVariant) : "info";
}

@Component({
  selector: "app-all-pages-alert",
  template: `
    @if (enabled) {
      <div class="-mt-32 mb-24" style="--p-corner-radius-small: 0" [style.background]="alertBackground">
        <div class="container">
          <stb-alert [rebrand]="true" [heading]="title" width="fluid" [type]="type">
            <div [innerHTML]="description"></div>
          </stb-alert>
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AlertModule],
})
export class AllPagesAlertComponent {
  private readonly fmsService: FmsService = inject(FmsService);

  readonly enabled: boolean = this.fmsService.getText("allPagesAlert.enabled", { logMissing: false }) === "true";
  readonly type: AlertVariant = resolveAlertType(this.fmsService.getText("allPagesAlert.type", { logMissing: false }));
  readonly title: string = this.fmsService.getText("allPagesAlert.title", { logMissing: false, logEmpty: false });
  readonly description: string = this.fmsService.getText("allPagesAlert.description", {
    logMissing: false,
    logEmpty: false,
  });
  readonly alertBackground: string = ALERT_BACKGROUNDS[this.type];
}
